import { render, staticRenderFns } from "./SearchPageHotelCardRightBlockRedirectButton.vue?vue&type=template&id=4b52967a&scoped=true"
import script from "./SearchPageHotelCardRightBlockRedirectButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageHotelCardRightBlockRedirectButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchPageHotelCardRightBlockRedirectButton.vue?vue&type=style&index=0&id=4b52967a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52967a",
  null
  
)

export default component.exports